/* eslint-disable import/no-default-export */
import Cookies from 'js-cookie';
import { loadDeployments } from 'app/gamma/src/modules/loaders/load-deployments';
import { State } from 'app/gamma/src/modules/types';
import React from 'react';
import { connect } from 'react-redux';
import { DeploymentsResponse } from 'app/gamma/src/types/responses';
import { Dispatch } from 'app/gamma/src/types';

import { ActiveHead, HydraChooser } from './hydra-chooser';

interface HydraChooserProps {
  loading: boolean;
  deployments: DeploymentsResponse;
}

interface DispatchProps {
  readonly dispatch: Dispatch;
}

interface StateProps {
  activeHead: ActiveHead;
}

interface AllProps extends HydraChooserProps, DispatchProps {}

class HydraChooserContainer extends React.Component<AllProps, StateProps> {
  constructor(props: AllProps) {
    super(props);
    let active: ActiveHead = {
      version: null,
      patch: null,
      name: null,
    };

    const cookie = Cookies.get('head');

    if (cookie) {
      try {
        active = JSON.parse(cookie);
        active.version = [active.version || 0, active.patch || 0].join('.');
      } catch (e) {
        console.error(e);
      }
    }

    this.state = {
      activeHead: active,
    };
  }

  componentDidMount() {
    this.props.dispatch(loadDeployments());
  }

  updateHead = (name: string) => {
    this.setState({
      activeHead: {
        ...this.state.activeHead,
        name,
      },
    });
  };

  updateVersion = (updatedVersion: string) => {
    this.setState({
      activeHead: {
        ...this.state.activeHead,
        version: updatedVersion,
      },
    });

    const [version, patch] = updatedVersion.split('.');
    const cookie = {
      name: this.state.activeHead && this.state.activeHead.name,
      version,
      patch,
    };

    if (parseInt(version, 10) < 0) {
      return;
    }

    Cookies.set('head', JSON.stringify(cookie), { path: '/' });
    document.location.reload();
  };

  render() {
    return (
      <HydraChooser
        updateHead={this.updateHead}
        updateVersion={this.updateVersion}
        activeHead={this.state.activeHead}
        {...this.props}
      />
    );
  }
}

function mapStateToProps(state: State) {
  return {
    loading: state.models.deployments.loading,
    deployments: state.models.deployments.heads,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HydraChooserContainer);
